<template lang="pug">
v-container.View.View--Profile
  v-card(v-if="!loading")
    v-card-text
      v-layout(column)
        .eyelet.text-uppercase Profilo
        .title.mb-3 Ciao {{ user.name }} {{ user.surname }}, bentornato!
        v-layout.mb-2(wrap data-cy="container_informations")
          v-flex(xs6)
            | Nome:
            .d-inline.body-2.ml-1 {{ user.name }}
          v-flex(xs6)
            | Cognome:
            .d-inline.body-2.ml-1 {{ user.surname }}
          v-flex(xs12)
            | Email:
            .d-inline.body-2.ml-1 {{ user.email }}
          v-flex(xs12 v-if="user.phone")
            | Telefono:
            .d-inline.body-2.ml-1 {{ user.phone }}
        v-layout(align-center justify-center)
          v-btn(color='primary' text :to='{name: "profile.edit"}') Modifica profilo
          br
          v-btn(@click="logout()") Logout
  template(v-else)
    Loading
</template>

<script>
import Loading from "@/components/Loading";
import Merchant from "@/api/Merchant";

export default {
  name: "CompanyProfile",
  components: { Loading },
  data: function() {
    return {
      loading: true,
      user: null
    };
  },
  async mounted() {
    this.loading = true;
    this.$emit("update:title", "Profilo");
    this.user = await Merchant.profile();
    this.loading = false;
  },

  methods: {
    logout() {
      this.$auth.logout();
      this.$emit("logout");
    }
  }
};
</script>
